import { List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import ProfileDataCard from "./ProfileDataCard";

interface VoluntaryActivitesSchoolProps {
  voluntarySchool: string[];
}

/**
 * This component displays the voluntary activities in school of an applicant.
 * @param voluntarySchool The voluntary activities in school
 * @returns The voluntary activities in school of an applicant.
 */
const VoluntaryActivitesSchool = ({ voluntarySchool }: VoluntaryActivitesSchoolProps) => {
  return (
    <ProfileDataCard
      title={
        <>
          Ehrenamtliche Tätigkeiten/
          <br />
          Engagement in der Schulzeit
        </>
      }
    >
      <List
        disablePadding
        sx={{ listStyleType: "square", listStylePosition: "outside", pl: voluntarySchool.length === 0 ? 0 : 2 }}
      >
        {voluntarySchool.length === 0 ? (
          <Typography>Keine Angaben</Typography>
        ) : (
          voluntarySchool.map((voluntarySchool, index) => {
            return (
              <ListItem key={index} disablePadding sx={{ display: "list-item" }}>
                <ListItemText primary={voluntarySchool} />
              </ListItem>
            );
          })
        )}
      </List>
    </ProfileDataCard>
  );
};

export default VoluntaryActivitesSchool;
